import { render, staticRenderFns } from "./upgradePkgs.vue?vue&type=template&id=94478230&scoped=true&"
import script from "./upgradePkgs.vue?vue&type=script&lang=js&"
export * from "./upgradePkgs.vue?vue&type=script&lang=js&"
import style0 from "./upgradePkgs.vue?vue&type=style&index=0&id=94478230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94478230",
  null
  
)

export default component.exports